module.exports = __webpack_public_path__ + "static/media/collectionc-centre-1.541eeecd.jpg";